export interface TradeAssetState { }

export const initialState: any = {
    firstCurrency: {},
    secondCurrency: {}
}